import React, { useState } from 'react';
import SubmitButton from '../formComponents/SubmitButton';
import ErrorMessage from '../formComponents/ErrorMessage';


const typeOptions = [
  'Website',
  'WhatsApp Group',
  'Facebook Page',
  'Instagram',
  'Twitter',
  'Discord',
  'YouTube',
  'Linktree',
  'Other',
];

export default function EditPublicLinksForm({ isOpen, initialLinks = [], onClose, onSave }) {
  const [links, setLinks] = useState(Array.isArray(initialLinks) ? initialLinks : []);
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (index, field, value) => {
  const newLinks = [...links];
  const updatedLink = { ...newLinks[index], [field]: value };
  newLinks[index] = updatedLink;
  setLinks(newLinks);
};


  const handleAdd = () => {
    setLinks([...links, { type: 'Other', label: '', url: '' }]);
  };

  const handleRemove = (index) => {
    const link = links[index];
    if (!window.confirm(`Remove "${link?.label || link?.type || 'this public link'}" when you save?`)) return;
    setLinks(links.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    try {
      setError(null);
      await onSave(links);
    } catch (err) {
      setError('Could not save links. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <form className="form" onSubmit={handleSubmit}>
      <h3 className="form-title">Edit Public Links</h3>

      {links.map((link, i) => (
        <div key={i} className="form-row link-row">
          <select
            className="input input-select"
            disabled={submitting}
            value={link.type}
            onChange={(e) => handleChange(i, 'type', e.target.value)}
          >
            {typeOptions.map((type) => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>
          <input
            className="input"
            disabled={submitting}
            type="text"
            placeholder="Label"
            value={link.label}
            onChange={(e) => handleChange(i, 'label', e.target.value)}
          />
          <input
            className="input"
            disabled={submitting}
            type="url"
            placeholder="https://example.com"
            value={link.url}
            onChange={(e) => handleChange(i, 'url', e.target.value)}
            required
          />
          <button type="button" className="remove-button" onClick={() => handleRemove(i)} disabled={submitting}>✕</button>
        </div>
      ))}

      <div className="form-actions">
  <div className="form-actions-left">
    <SubmitButton
      type="button"
      label="Add Link"
      onClick={handleAdd}
      variant="secondary"
      disabled={submitting}
    />
  </div>
  <div className="form-actions-right">
    <SubmitButton
      type="button"
      label="Cancel"
      onClick={onClose}
      variant="ghost"
      size="sm"
      disabled={submitting}
    />
    <SubmitButton
      type="submit"
      label={submitting ? 'Saving…' : 'Save Links'}
      variant="primary"
      disabled={submitting}
    />
  </div>
</div>



      {error && <ErrorMessage message={error} />}
    </form>
  );
}
